module.exports = __webpack_public_path__ + "img/used-car-careful.e1defebd.jpg";